import { render, staticRenderFns } from "./BuscaInstFiltros.vue?vue&type=template&id=053bab88&scoped=true"
import script from "./BuscaInstFiltros.vue?vue&type=script&lang=js"
export * from "./BuscaInstFiltros.vue?vue&type=script&lang=js"
import style0 from "./BuscaInstFiltros.vue?vue&type=style&index=0&id=053bab88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bab88",
  null
  
)

export default component.exports